export function formatTimestamp() {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
    });
    return formatter.format(date);
}
